document.addEventListener("DOMContentLoaded", () => {
  const INSURANCE_VARIANT_IDS = {
    500: "45603252174999",
    1000: "45603252207767",
    1500: "45603252240535",
    2000: "45603252273303",
    2500: "45603252306071",
    3000: "45603252338839",
    3500: "45603252371607",
    4000: "45603252404375",
    4500: "45603252437143",
    5000: "45603252469911",
    5500: "45603252502679",
    6000: "45603252535447",
    6500: "45603252568215",
    7000: "45603252600983",
    7500: "45603252633751",
    8000: "45528735350935",
    8500: "45528735383703",
    9000: "45528735416471",
    9500: "45528735482007",
    10000: "45528735514775",
    11000: "45528735547543",
    12000: "45528735613079",
    13000: "45528735678615",
    14000: "45528735711383",
    15000: "45528735776919",
    16000: "45528735809687",
    17000: "45528735875223",
    18000: "45528735907991",
    19000: "45633534591127",
    20000: "45633534623895",
  };

  const ALL_INSURANCE_VARIANTS = Object.values(INSURANCE_VARIANT_IDS);
  const currencyCode = window.Shopify?.currency?.active || "USD";
  const currencyRate = window.Shopify?.currency?.rate || 1;

  // 加上时间戳防止 AJAX 购物车缓存旧数据
  const getCart = () => fetch(`/cart.js?v=${new Date().getTime()}`).then((res) => res.json());

  // 【核心优化】计算真实总价：剔除购物车里已经有的保险，防止价格套娃
  const getTrueCartSubtotal = (cart) => {
    const insuranceTotal = cart.items
      .filter((item) => ALL_INSURANCE_VARIANTS.includes(item.variant_id.toString()))
      .reduce((sum, item) => sum + item.final_line_price, 0);
    return cart.total_price - insuranceTotal;
  };

  // 根据真实金额判断变体 ID
  const determineVariantId = (true_total_price) => {
    const price = true_total_price / 100 / currencyRate; // 转为 USD 基准
    const tiers = Object.keys(INSURANCE_VARIANT_IDS)
      .map(Number)
      .sort((a, b) => a - b);
    
    for (let i = 0; i < tiers.length; i++) {
      if (price <= tiers[i]) return INSURANCE_VARIANT_IDS[tiers[i]];
    }
    return INSURANCE_VARIANT_IDS[tiers[tiers.length - 1]]; // 超出最大值时的兜底
  };

  // 【核心优化】使用 /cart/update.js 批量移除所有档位保险，只发 1 个网络请求
  const removeAllInsuranceVariants = async (cart) => {
    const updates = {};
    cart.items.forEach((item) => {
      if (ALL_INSURANCE_VARIANTS.includes(item.variant_id.toString())) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length > 0) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });
    }
  };

  const updateInsuranceLabel = (truePriceCents) => {
    const labelEl = document.querySelector('label[for="add-insurance-checkbox"] strong');
    if (labelEl) {
      const estimatedFee = (truePriceCents / 100) * 0.02;
      const formatted = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: 2,
      }).format(estimatedFee);

      labelEl.textContent = `Add Shipping Insurance (2%) ≈ ${formatted}`;
    }
  };

  let isProcessing = false;

  // 【核心优化】专职负责同步 UI 状态，不负责绑定事件
  const syncUIAfterCartUpdate = () => {
    // 延迟 100ms 等待抽屉购物车 DOM 渲染完成
    setTimeout(async () => {
      const checkbox = document.getElementById("add-insurance-checkbox");
      if (!checkbox) return;

      try {
        const cart = await getCart();
        const trueSubtotal = getTrueCartSubtotal(cart);
        
        const hasInsuranceInCart = cart.items.some((item) =>
          ALL_INSURANCE_VARIANTS.includes(item.variant_id.toString())
        );

        checkbox.checked = hasInsuranceInCart;
        updateInsuranceLabel(trueSubtotal);
      } catch (err) {
        console.error("Cart load error:", err);
      }
    }, 100);
  };

  // 【核心优化】使用事件代理：把事件绑在 document 上，无论 checkbox 怎么被 AJAX 重新渲染，都能点
  document.addEventListener("change", async (e) => {
    if (e.target.id !== "add-insurance-checkbox" || isProcessing) return;

    const checkbox = e.target;
    isProcessing = true;
    checkbox.disabled = true;

    try {
      const updatedCart = await getCart();
      const trueSubtotal = getTrueCartSubtotal(updatedCart);
      const newVariantId = determineVariantId(trueSubtotal);

      // 先批量清理旧保险
      await removeAllInsuranceVariants(updatedCart);

      // 如果打勾了，加入对应的最新保险
      if (checkbox.checked && newVariantId) {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: newVariantId, quantity: 1 }),
        });

        if (!res.ok) throw new Error("Add insurance failed");
      }

      // 触发主题原生的购物车刷新
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
      
    } catch (err) {
      console.error("Insurance update error:", err);
      checkbox.checked = !checkbox.checked; // 失败时退回状态
    } finally {
      checkbox.disabled = false;
      isProcessing = false;
      syncUIAfterCartUpdate();
    }
  });

  // 监听原生购物车事件，同步金额和勾选状态
  document.addEventListener("cart:updated", syncUIAfterCartUpdate);

  // 【核心优化】只在 DOM 中出现新的 Checkbox 时做轻量级检查，避免无效的网络请求
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        const checkbox = document.getElementById("add-insurance-checkbox");
        if (checkbox && !checkbox.dataset.synced) {
          checkbox.dataset.synced = "true";
          syncUIAfterCartUpdate();
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // 初始加载执行一次
  syncUIAfterCartUpdate();
});